import React, { memo, useCallback } from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';
import { Button } from '@picsio/ui';
import { MediaMatching } from '@picsio/icons';
import { useDispatch } from 'react-redux';

import { navigate } from '../../helpers/history';
import { getRootId } from '../../store/utils/collections';
import l18n from '../../shared/strings';
import Logger from '../../services/Logger';
import { changeBulkMediaMatchViewMode } from '../../store/actions/main';
import s from './styles.module.scss';

const Tabs = memo(({
  list, active, onChange, showBulkMediaMatch = false, className = '', tabLabelClassName = '',
}) => {
  const dispatch = useDispatch();
  const handleClickButton = useCallback((tabId) => () => {
    onChange(tabId);
  }, [onChange]);

  const onOpenMediaMatch = useCallback(() => {
    Logger.log('User', 'BulkMediaMatchOpenClicked');
    const rootId = getRootId();
    dispatch(changeBulkMediaMatchViewMode(true));
    navigate(`/search?collectionIds=${rootId}&isMediaMatch=true`);
  }, [dispatch]);

  return (
    <div className={cn(s.tabs, className)}>
      {list.map((tab) => (
        <button
          key={tab.id}
          className={cn(s.tab, { [s.active]: active === tab.id })}
          type="button"
          onClick={handleClickButton(tab.id)}
        >
          <If condition={tab.startIcon}>
            {tab.startIcon}
          </If>
          <span className={cn(s.tabLabel, tabLabelClassName)}>{tab.text}</span>
          <If condition={tab.icon}>
            {tab.icon}
          </If>
        </button>
      ))}
      <If condition={showBulkMediaMatch}>
        <div className={s.buttonBulkMedia}>
          <Button
            color="primary"
            componentProps={{
              'data-testid': 'btnBulkMediaMatch',
            }}
            startIcon={<MediaMatching />}
            size="xl"
            onClick={onOpenMediaMatch}
          >
            {l18n.BULK_MEDIA_MATCH.BTN_OPEN_PLUGIN}
          </Button>
        </div>
      </If>
    </div>
  );
});

Tabs.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    text: PropTypes.string.isRequired,
    startIcon: PropTypes.node,
    icon: PropTypes.node,
  })).isRequired,
  active: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  className: PropTypes.string,
  tabLabelClassName: PropTypes.string,
  showBulkMediaMatch: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

Tabs.defaultProps = {
  className: '',
  tabLabelClassName: '',
  showBulkMediaMatch: false,
};

export default Tabs;
